import { tryMailPlus0724Metadata } from '@proton/payments/core/coupon-config/configs/try-mail-plus-0724';

import type { CouponConfig } from './interface';

export const tryMailPlus0724Config: CouponConfig = {
    ...tryMailPlus0724Metadata,
};
